<header id="header">
  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css"
  />
  <nav class="navbar navbar-expand-lg fixed-top navbar-light shadow-sm p-1">

    <a class="navbar-brand ml-xl-5" href="#">
      <img
        style="width: 150px; height: auto;"
        class="img-fluid"
        src="/assets/img/prefeitura-mairipora.png"
        alt="Secretaria Municipal de Educação"
        title="Secretaria Municipal de Educação"
      />
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarContent"
      aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarContent">
        <ul class="navbar-nav mx-auto text-center">
      
        <li class="nav-item d-xl-none d-lg-none mt-4 mb-4">
          <a href="#">
            <img
              style="height: 40px"
              class="img-fluid logo-mobile-hide"
              src="/assets/img/educasim.png"
              alt="Secretaria Municipal de Educação"
              title="Secretaria Municipal de Educação"
            />
          </a>
        </li>

        <li class="nav-item p-1">
  <a href="/#home" routerLink="/" fragment="home">
    <button type="button" class="btn">
      <i class="fas fa-home fa-2x text-primary d-block"></i>
      <span class="btn-label">HOME</span>
    </button>
  </a>
</li>
<li class="nav-item p-1">
  <a href="/#comunicados" routerLink="/" fragment="comunicados">
    <button type="button" class="btn">
      <i class="fas fa-bullhorn fa-2x text-warning d-block"></i>
      <span class="btn-label">FIQUE POR DENTRO</span>
    </button>
  </a>
</li>
        <li class="nav-item p-1">
  <a href="/#instituicao" routerLink="/" fragment="instituicao" class="btn">
    <i class="fas fa-university fa-2x text-success d-block"></i>
    <span class="btn-label">INSTITUIÇÃO</span>
  </a>
</li>
       <li class="nav-item p-1">
  <a href="/#contato" routerLink="/" fragment="contato">
    <button type="button" class="btn">
      <i class="fas fa-envelope fa-2x text-danger d-block"></i>
      <span class="btn-label">CONTATO</span>
    </button>
  </a>
</li>

<li class="nav-item p-1">
  <a href="http://professor.mairiporaeducasim.com.br" target="_blank">
    <button type="button" class="btn">
      <i class="fas fa-cogs fa-2x text-danger d-block"></i>
      <span class="btn-label">GESTÃO EDUCACIONAL</span>
    </button>
  </a>
</li>

<li class="nav-item p-1">
  <a href="https://alunos.mairiporaeducasim.com.br" target="_blank">
    <button type="button" class="btn">
      <i class="fas fa-user-graduate fa-2x text-info d-block"></i>
      <span class="btn-label">PORTAL DO ALUNO</span>
    </button>
  </a>
</li>
      </ul>
     
      <div class="d-none d-lg-block pr-xl-5">
        <img
          style="height: 40px"
          class="img-fluid"
          src="/assets/img/educasim.png"
          alt="Secretaria Municipal de Educação"
          title="Secretaria Municipal de Educação"
        />
      </div>
    </div>
  </nav>
</header>